var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TestLayout',{attrs:{"title":"Creative Size"}},[_c('div',{staticStyle:{"grid-column":"1 / -1"}},[(_vm.creative)?_c('CreativeDetails',{staticClass:"p-0",attrs:{"creative":_vm.creative}}):_vm._e(),_c('pre',{staticClass:"mt-24"},[_vm._v(_vm._s(_vm.state))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }